<template>
    <TestCarte />
</template>
<script setup>
import TestCarte from '@/components/map/TestCarte.vue';
</script>